import { FloatingTooltipContentText } from '../../../../Floating'

import { getCalendarGridWeekBlockHintAdditionalText } from './CalendarGridWeekBlockTooltipContent.utils'

function CalendarGridWeekBlockTooltipContent({
  hint,
  isHintDetailed,
  timeLabel,
  title,
}) {
  return isHintDetailed ? (
    <FloatingTooltipContentText
      additionalText={getCalendarGridWeekBlockHintAdditionalText({
        hint,
        timeLabel,
      })}
      text={title}
    />
  ) : (
    hint
  )
}

export default CalendarGridWeekBlockTooltipContent
